<template>
    <div>
        <workshops-filter
            :title="title"
            :color="isAja ? '#4E983C' : color"
            :search="search"
            :options="options"
            :loading="loading"
            :all-departments="allDepartments"
            :all-cities="allCities"
            :departments-loading="departmentsLoading"
            :cities-loading="citiesLoading"
            :professionals-names="professionalsNames"
            :professionals-names-loading="professionalsNamesLoading"
            :slider="slider"
            :total="total"
            :is-aja="isAja"
            :is-oncommence="isOncommence"
            @update:options="$emit('update:options', $event)"
        />

        <!-- Bandeau -->
        <!-- TMP : hide ONCO'MMENCE Workshops -->
        <v-card v-if="showBanner" elevation="4" :color="color" dark class="mb-4">
            <v-card-text class="pa-8">
                <v-row align="center" class="headline" no-gutters>
                    <v-col cols="1">
                        <v-icon x-large class="mr-2">info</v-icon>
                    </v-col>
                    <v-col cols="8" class="white--text">
                        Afin d'améliorer votre expérience, 
                        nous vous invitons à vous inscrire à une session <strong>ONCO'MMENCE</strong> 
                        avant de vous inscrire aux ateliers de remédiation cognitive
                    </v-col>
                    <v-col cols="3" class="text-right">
                        <v-btn depressed @click="$router.push({ name: 'WorkshopsOncommence' })">
                            <v-icon>arrow_forward</v-icon>
                            <span class="ml-2">ONCO'MMENCE</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Skeleton loader initial -->
        <v-row v-if="loading" align="stretch">
            <v-col v-for="n in 6" :key="n" cols="12" sm="6" md="4">
                <v-skeleton-loader type="card" class="mx-auto " :class="{'aja-skeleton': isAja}" height="300"></v-skeleton-loader>
            </v-col>
        </v-row>

        <!-- Liste des ateliers -->
        <template v-else>
            <v-data-iterator 
                :items="workshops"
                :options="options"
                @update:options="$emit('update:options', $event)"
                :server-items-length="total"
                :loading="loading"
                hide-default-footer
            >
                <template v-slot:default="props">
                    <!-- Liste des ateliers -->
                    <v-row align="stretch">
                        <v-col v-for="(workshop,k) in props.items" :key="workshop.id" cols="12" sm="6" md="4">
                            <WorkshopCard 
                                ref="WorkshopCard" 
                                :key="workshop.id" 
                                v-model="workshops[k]"
                                :link="{ name: isAja ? 'AJAWorkshop' : 'Workshop', params: {id: workshop.id} }"
                                :options="options"
                                :type="workshop.type"
                                :is-aja="isAja"
                            />
                        </v-col>
                    </v-row>

                    <!-- Skeleton loader pour le chargement infini -->
                    <v-row v-if="loadingMore" align="stretch" class="mt-4">
                        <v-col v-for="n in 6" :key="n" cols="12" sm="6" md="4">
                            <v-skeleton-loader type="card" :class="'mx-auto ' + (isAja ? 'aja-skeleton' : '')" height="300"></v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <!-- Message quand tous les ateliers sont chargés -->
                    <v-row v-if="!hasMore && workshops.length > 0" align="center" class="mt-4">
                        <v-col cols="12" class="text-center">
                            <v-chip
                                color="grey"
                                text-color="white"
                                class="text-subtitle-2"
                            >
                                Tous les ateliers ont été chargés
                            </v-chip>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:no-data>
                    <v-card elevation="4" class="mt-5" :color="isAja ? '#1a3a47' : undefined">
                        <v-card-text class="text-center">
                            <v-icon x-large>sentiment_satisfied</v-icon>
                            <br>
                            <span class="title">Aucun atelier trouvé</span>
                        </v-card-text>
                    </v-card>
                </template>
            </v-data-iterator>
        </template>
    </div>
</template>

<script>
import WorkshopsFilter from '@/components/workshops/WorkshopsFilter'
import WorkshopCard from '@/components/workshops/Card'

export default {
    name: 'WorkshopsList',
    components: {
        WorkshopsFilter,
        WorkshopCard
    },
    props: {
        title: {
            type: String,
            required: true
        },
        showBanner: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'primary'
        },
        workshops: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        search: {
            type: Object,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        loadingMore: {
            type: Boolean,
            default: false
        },
        allDepartments: {
            type: Array,
            default: () => []
        },
        allCities: {
            type: Array,
            default: () => []
        },
        departmentsLoading: {
            type: Boolean,
            default: false
        },
        citiesLoading: {
            type: Boolean,
            default: false
        },
        professionalsNames: {
            type: Array,
            default: () => []
        },
        professionalsNamesLoading: {
            type: Boolean,
            default: false
        },
        slider: {
            type: Array,
            default: () => []
        },
        hasMore: {
            type: Boolean,
            default: true
        },
        isAja: {
            type: Boolean,
            default: false
        },
        isOncommence: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:options']
}
</script> 